import React from "react";
import CommonQuestions from "../components/commonQuestions";

const NewCustomer = () => {
  return (
    <div>
      <CommonQuestions OrderType={"New Customer"}/>
    </div>
  );
};

export default NewCustomer;
